import { Injectable } from '@angular/core'
import { HttpService } from '@surgetech-eu/core'
import { Observable } from 'rxjs'
import { LibraryModel } from '../models'

export interface CountryOfOrigin {
    id: string
    code?: string
}

export interface RegionOfSourcing extends LibraryModel {
    countryOfOrigin?: CountryOfOrigin | null
    new?: boolean
}

export const url = '/libraries/management/types/regionOfSourcing/entries'

@Injectable()
export class RegionOfSourcingService {
    constructor(private http: HttpService) {}

    getAll(): Observable<RegionOfSourcing[]> {
        return this.http.get<RegionOfSourcing[]>(url)
    }

    remove(data: RegionOfSourcing[]): Observable<void> {
        return this.http.delete(url, { data })
    }

    create(data: RegionOfSourcing[]): Observable<RegionOfSourcing[]> {
        return this.http.post<RegionOfSourcing[]>(url, { data })
    }

    update(data: RegionOfSourcing[]): Observable<RegionOfSourcing[]> {
        return this.http.put<RegionOfSourcing[]>(url, { data })
    }
}
